import React from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'

import { CarInfo } from './index'
import ArticleCard from 'Components/ugc/article-card'

interface IProps {
  list: any[]
  car_info: CarInfo
}

const FeedList = ({ list, car_info }: IProps) => {
  const handleItemClick = (
    rank: number,
    content_type: number,
    group_id: string
  ) => () => {
    const { motor_id, motor_name, motor_type } = car_info
    sendTeaCommEvent('click_ugc_forum_feed_content', {
      rank,
      group_id,
      content_type,
      motor_id,
      motor_name,
      motor_type,
      sub_tab: '', // todo---
    })
  }
  return (
    <div className="feed-list">
      {list.map((item, index) => {
        const { ugcType, info, unique_id_str } = item
        info.group_id = unique_id_str
        info.ugcType = ugcType
        return (
          <div
            className="feed-item fade-in"
            key={item.unique_id_str + index}
            onClick={() => handleItemClick(index, ugcType, unique_id_str)}
          >
            <ArticleCard {...item} />
          </div>
        )
      })}
      <style jsx>
        {`
          .feed-list {
            padding-top: 16px;
          }
          .feed-item {
            position: relative;
            padding: 24px 24px 26px 24px;
            background-color: white;
            margin-bottom: 8px;
            width: 800px;
          }
          .fade-in {
            animation: fadeIn 0.3s ease;
          }
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  )
}

export default FeedList
